import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useUserNames } from "@/lib/useUserNames";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [filtered, setFiltered] = useState([]);
  const nameOf = useUserNames();

  useEffect(() => { api.get("/audit/logs", { params: { limit: 500 } }).then(({ data }) => { setItems(data.items); setFiltered(data.items); }); }, []);
  useEffect(() => {
    if (!q) { setFiltered(items); return; }
    const s = q.toLowerCase();
    setFiltered(items.filter(i => JSON.stringify(i).toLowerCase().includes(s)));
  }, [q, items]);

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <div className="section-label">Compliance · NABH</div>
        <h1 className="font-heading text-3xl font-semibold">Audit trail</h1>
        <p className="mt-1 text-sm text-ink-muted">Every create / update / status-change / login action is captured here for accreditation and incident review.</p>
      </div>

      <Card className="p-4">
        <Input placeholder="Search by user, action, entity…" value={q} onChange={e => setQ(e.target.value)} data-testid="audit-search" />
      </Card>

      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary text-xs uppercase tracking-wider text-ink-muted">
              <tr><th className="px-3 py-2 text-left">When</th><th className="px-3 py-2 text-left">User</th><th className="px-3 py-2 text-left">Role</th><th className="px-3 py-2 text-left">Action</th><th className="px-3 py-2 text-left">Entity</th><th className="px-3 py-2 text-left">Details</th></tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filtered.length === 0 && <tr><td colSpan="6" className="px-3 py-10 text-center text-ink-muted">No audit entries.</td></tr>}
              {filtered.slice(0, 300).map(a => (
                <tr key={a.id}>
                  <td className="px-3 py-2 text-xs text-ink-muted">{(a.created_at||"").slice(0,19).replace("T"," ")}</td>
                  <td className="px-3 py-2 text-xs">
                    <div className="font-medium">{nameOf(a.user_email, a.user_email)}</div>
                    {a.user_email && nameOf(a.user_email, "") !== a.user_email && (
                      <div className="text-[10px] font-mono text-ink-muted">{a.user_email}</div>
                    )}
                  </td>
                  <td className="px-3 py-2 text-xs"><Badge variant="outline">{a.user_role}</Badge></td>
                  <td className="px-3 py-2 capitalize">{a.action.replace(/_/g," ")}</td>
                  <td className="px-3 py-2 capitalize">{a.entity_type}</td>
                  <td className="px-3 py-2 text-[11px] font-mono text-ink-muted">{a.details ? JSON.stringify(a.details).slice(0, 90) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
